
export default function League() {
    return (
        <div className="mt-5 col-12 col-md-4">
            <div className="full-height align-center">
                <div className="p-3 grey-3 index-card-background-full">
                    <img
                        src={process.env.PUBLIC_URL + "/images/gaming/leagueIcon.png"}
                        className="index-card-icon"
                        alt="leagueIcon"
                    />
                    <div className="index-card-header">League Of Legends</div>
                    <div className="left">
                    I have been playing for around 10 years. My position of choice is support as Xerath as my main pick.
                    Most of my time is normal draft, and I avoid playing rank.
                    </div>
                    <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                <a href="https://masterychart.com/profile/na/Chippy+Cheese-NA1">
                    <img
                        src={process.env.PUBLIC_URL + "/images/gaming/leagueMastery.png"}
                        className="league-stat-icon"
                        alt="League mastery"
                    />
                </a>

                <a href="https://op.gg/lol/summoners/na/Chippy%20Cheese-NA1">
                    <img
                        src={process.env.PUBLIC_URL + "/images/gaming/leagueRank.png"}
                        className="league-stat-icon"
                        alt="League rank"
                    />
                </a>
            </div>
                </div>
            </div>
        </div>
    );
}